module.exports = __webpack_public_path__ + "static/media/fort-collins-tablet.3e3de03d.webp";